import React, { Component } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import "./Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
const queryString = window.location.search;
// parse the query string's paramters
const urlParams = new URLSearchParams(queryString);
// To get a parameter simply write something like the follwing
//const language_id: number = parseInt(urlParams.get('language') as string, 10);
const country = urlParams.get('country') as string;

/*text arrays indexed by integer: 0=ENG, 1=DEU, 2=NLD*/
interface StringArray {
    [index: string]: number;
}
let languageResources: StringArray;
languageResources = { ["ENG"]: 0, ["DEU"]: 1,["NLD"]: 2 };
const language_id: number = languageResources[country];

const lblUserText = ['User ID', 'Benutzer','User ID'];
const lblPasswordText = ['Password', 'PIN', 'Password'];
const lblbtnSubmitText = ['Submit', 'Best\u00E4tigen','Submit'];

class Login extends Component {
    state = {
        layoutName: "default",
        username: "",
        password: "",
        controlInAction: "",
        authorizeEndPoint: "",
        antiForgeryToken: "",
        client_id: "",
        redirect_uri: "",
        state: "",
        country: "",
        isSubmitting: false // Add flag to prevent double submission
    //, language_id: 0 //come from OAuthService.GetCashMahineDeviceLangByClientId
    };

    keyboard: any;

    onChangeKeyboard = (input: string) => {
        if (this.state.controlInAction === "username") {
            this.setState({
                username: input
            });
        }
        else if (this.state.controlInAction === "password") {
            this.setState({
                password: input
            });
        }
    };

    onChangeInput = (event: React.BaseSyntheticEvent) => {
        let input = event.target.value;
        if (event.target.id === "password") {
            this.setState(
                {
                    password: input,
                    controlInAction: event.target.id
                },
                () => {
                    this.keyboard.setInput(input);
                }
            );
        }
        else {
            this.setState(
                {
                    username: input,
                    controlInAction: event.target.id
                },
                () => {
                    this.keyboard.setInput(input);
                }
            );
        }
    };

    componentDidMount = async () => {
        // Parse query parameters from URL
        const params = new URLSearchParams(window.location.search);

        this.setState({
            authorizeEndPoint: window.location.origin + "/OAuth/Authorize",
            // Store OAuth parameters in state
            client_id: params.get("client_id") || "",
            redirect_uri: params.get("redirect_uri") || "",
            state: params.get("state") || "",
            country: params.get("country") || ""
        });

        try {
            const response = await fetch(window.location.origin + "/OAuth/GetAntiForgeryToken");
            const data = await response.json();
            this.setState({
                antiForgeryToken: data.token
            });
        } catch (error) {
            console.error("Failed to fetch anti-forgery token:", error);
        }
    }

    // Add handler to prevent double form submission
    handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        if (this.state.isSubmitting) {
            event.preventDefault();
            console.warn("Form submission already in progress");
            return;
        }

        this.setState({ isSubmitting: true });
        // Let the form submit normally
    }

    render() {
        return (
            <div className="container col-md-8">
                {/*<img className="logosize" src="data:image/png;base64,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" />*/}
                <main className="login-form">
                    <div className="card">
                        {/*<div className="card-header"><h6>Welcome to Metro Cash Machine</h6></div>*/}
                        <div className="card-header"><h6></h6></div>
                        <div className="card-header"><h6></h6></div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-4 col-md-4">
                                    <form className="form-horizontal m-3" method="post" action={this.state.authorizeEndPoint} onSubmit={this.handleSubmit}>
                                        <input type="hidden" name="__RequestVerificationToken" value={this.state.antiForgeryToken} />
                                        <input type="hidden" name="client_id" value={this.state.client_id} />
                                        <input type="hidden" name="redirect_uri" value={this.state.redirect_uri} />
                                        <input type="hidden" name="state" value={this.state.state} />
                                        <input type="hidden" name="country" value={this.state.country} />
                                        <div className="form-group pb-3">
                                            {/*<label id="lblUser">{lblUserText[this.state.language_id]}</label>:*/}
                                            <label id="lblUser">{lblUserText[language_id]}</label>:
                                            {/*<label id="lblUser">{'Best\u00E4tigen'}</label>:*/}
                                            <input type="number"
                                                min="0"
                                                id="username"
                                                name="username"
                                                value={this.state.username}
                                                className="form-control"
                                                placeholder={""}
                                                onChange={e => this.onChangeInput(e)}
                                                onFocus={e => this.onChangeInput(e)}
                                                required
                                            />
                                        </div>
                                        <div className="form-group pb-3">
                                            {/*<label id="lblPassword">{lblPasswordText[this.state.language_id]}</label>:*/}
                                            <label id="lblPassword">{lblPasswordText[language_id]}</label>:
                                            <input type="password"
                                                min="0"
                                                id="password"
                                                name="password"
                                                className="form-control"
                                                onChange={e => this.onChangeInput(e)}
                                                value={this.state.password}
                                                onFocus={e => this.onChangeInput(e)}
                                                required
                                            />
                                        </div>
                                        <div className="form-group pb-3">
                                            {/*<button type="submit" className="btn btn-default btn-primary w-100">{lblbtnSubmitText[this.state.language_id]}</button>*/}
                                            <button type="submit" className="btn btn-default btn-primary w-100" disabled={this.state.isSubmitting}>
                                                {this.state.isSubmitting ? "Submitting..." : lblbtnSubmitText[language_id]}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-lg-8 col-md-8">
                                    <Keyboard
                                        keyboardRef={(r: any) => (this.keyboard = r)}
                                        theme={"hg-theme-default hg-layout-numeric numeric-theme"}
                                        layoutName={this.state.layoutName}
                                        onChange={(input: string) => this.onChangeKeyboard(input)}
                                        disableCaretPositioning={true}
                                        layout={{
                                            default: ["1 2 3", "4 5 6", "7 8 9", "{//} 0 {//}", "{bksp}"]
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

export default Login;
